import { Colors } from "@/constants/Colors"
import { WEB_MOBILE_FRAME_WIDTH } from "@/constants/WebLayout"
import { useClientOnlyValue } from "@/hooks/useClientOnlyValue"
import type { BottomTabBarButtonProps } from "@react-navigation/bottom-tabs"
import { Tabs } from "expo-router"
import { Home, ListTodo, LucideIcon, Network, Sparkles, UserRound } from "lucide-react-native"
import { Platform, TouchableOpacity } from "react-native"
import { SafeAreaView } from "react-native-safe-area-context"

function TabBarIcon({ Icon, color }: { Icon: LucideIcon; color: string }) {
  return <Icon size={24} color={color} strokeWidth={2.2} />
}

function CustomTabBarButton({
  children,
  onPress,
  onLongPress,
  accessibilityState,
}: BottomTabBarButtonProps) {
  const focused = accessibilityState?.selected

  return (
    <TouchableOpacity
      onPress={onPress}
      onLongPress={onLongPress}
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        marginHorizontal: 2,
        marginVertical: 7,
        borderRadius: 14,
        backgroundColor: focused ? `${Colors.dark.primary}24` : "transparent",
        borderWidth: focused ? 1 : 0,
        borderColor: focused ? `${Colors.dark.primary}73` : "transparent",
      }}
    >
      {children}
    </TouchableOpacity>
  )
}

const tabBarStyle = {
  backgroundColor: Colors.dark.surfaceSecondary,
  borderTopColor: Colors.dark.surfaceTertiary,
  borderTopWidth: 1,
  height: 74,
  paddingTop: 8,
  paddingBottom: 10,
  position: "fixed" as "absolute",
}

export default function TabLayout() {
  return (
    <SafeAreaView
      className="flex-1"
      edges={["bottom"]}
      style={{ backgroundColor: Colors.dark.surface }}
    >
      <Tabs
        screenOptions={{
          headerShown: useClientOnlyValue(false, true),
          tabBarStyle:
            Platform.OS === "web"
              ? {
                  ...tabBarStyle,
                  maxWidth: WEB_MOBILE_FRAME_WIDTH,
                  width: "100%",
                  marginHorizontal: "auto",
                }
              : tabBarStyle,
          tabBarActiveTintColor: Colors.dark.primary,
          tabBarInactiveTintColor: Colors.dark.textSecondary,
          tabBarButton: CustomTabBarButton,
          tabBarLabelStyle: { fontSize: 11, fontWeight: "700" },
          ...(Platform.OS === "web"
            ? {
                sceneStyle: {
                  width: "100%",
                  maxWidth: WEB_MOBILE_FRAME_WIDTH,
                  marginHorizontal: "auto",
                },
              }
            : {}),
        }}
      >
        <Tabs.Screen
          name="index"
          options={{
            title: "Home",
            headerShown: false,
            tabBarIcon: ({ color }) => <TabBarIcon Icon={Home} color={color} />,
          }}
        />
        <Tabs.Screen
          name="tree"
          options={{
            title: "Skill Tree",
            headerShown: false,
            tabBarIcon: ({ color }) => <TabBarIcon Icon={Network} color={color} />,
          }}
        />
        <Tabs.Screen
          name="proof"
          options={{
            title: "Coach",
            headerShown: false,
            tabBarIcon: ({ color }) => <TabBarIcon Icon={Sparkles} color={color} />,
          }}
        />
        <Tabs.Screen
          name="tasks"
          options={{
            title: "Tasks",
            headerShown: false,
            tabBarIcon: ({ color }) => <TabBarIcon Icon={ListTodo} color={color} />,
          }}
        />
        <Tabs.Screen
          name="profile"
          options={{
            title: "Passport",
            headerShown: false,
            tabBarIcon: ({ color }) => <TabBarIcon Icon={UserRound} color={color} />,
          }}
        />
      </Tabs>
    </SafeAreaView>
  )
}
